webpackJsonp([246501157640856],{

/***/ 277:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  margin-bottom: ", ";\n"], ["\n  margin-bottom: ", ";\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(37);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactMoment = __webpack_require__(254);
	
	var _reactMoment2 = _interopRequireDefault(_reactMoment);
	
	var _reactFlexboxGrid = __webpack_require__(21);
	
	var _content = __webpack_require__(22);
	
	var _lists = __webpack_require__(101);
	
	var _markdownComponents = __webpack_require__(49);
	
	var _typography = __webpack_require__(23);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var SpacedPlainList = _lists.PlainList.extend(_templateObject, (0, _typography.rhythm)(1));
	
	var PastEvent = function PastEvent(_ref) {
	  var event = _ref.event;
	  return _react2.default.createElement(
	    _lists.PlainListItem,
	    null,
	    _react2.default.createElement(
	      _gatsbyLink2.default,
	      { to: event.fields.slug },
	      _react2.default.createElement(
	        _reactFlexboxGrid.Row,
	        { between: "xs", center: "xs", middle: "xs" },
	        _react2.default.createElement(
	          _reactFlexboxGrid.Col,
	          { lg: 6, md: 12 },
	          event.frontmatter.title
	        ),
	        _react2.default.createElement(
	          _reactFlexboxGrid.Col,
	          { lg: 6, md: 12 },
	          _react2.default.createElement(
	            _content.Dimmed,
	            null,
	            _react2.default.createElement(
	              _reactMoment2.default,
	              { format: "DD MMM YYYY, HH:mm" },
	              event.frontmatter.date
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = function (_ref2) {
	  var data = _ref2.data;
	
	  var events = data.events.edges;
	
	  var content = _react2.default.createElement(
	    _lists.PlainListItem,
	    null,
	    _react2.default.createElement(
	      _content.Dimmed,
	      null,
	      "No past events"
	    )
	  );
	
	  if (events.length > 0) {
	    content = events.map(function (event, index) {
	      return _react2.default.createElement(PastEvent, { key: index, event: event.node });
	    });
	  }
	
	  return _react2.default.createElement(
	    _content.Paper,
	    { centered: data.page.frontmatter.centered },
	    (0, _markdownComponents.renderAst)(data.page.htmlAst),
	    _react2.default.createElement(
	      SpacedPlainList,
	      null,
	      content
	    )
	  );
	};
	
	var query = exports.query = "** extracted graphql fragment **";

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-events-js-e3823070781c80126fbe.js